import React, { useState, useEffect } from 'react';
import { useAuthState } from "react-firebase-hooks/auth";
import '../../../src/index.css'
import { auth, logout } from "../../firebase";
import { Layout, Col, Divider, Row, Button } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";

const style = {
  background: '#fff',
  padding: '8px 0',
  textAlign: 'center',
};

const headerStyle = {
  textAlign: 'left',
  color: '#fff',
  height: 64,
  paddingInline: 48,
  lineHeight: '64px',
};

function Hub() {

    const [user, loading, error] = useAuthState(auth);
    const navigate = useNavigate();

    const { Content, Footer, Header } = Layout;


    useEffect(() => {
        if (loading) return;
        if (!user) return navigate("/");
    }, [user, loading]);

    const handleLogOut = () =>{
      logout();
  }

  return( 
  
  <Layout>
    <Layout>
    <Header style={headerStyle}>
      Argos HUB Dashboard
      <Button key="2" onClick={handleLogOut}>{<LogoutOutlined />}Abmelden</Button>
    </Header>
      <Content
        style={{
          margin: '24px 16px 0',
        }}
      >
        <div
          className="site-layout-background"
          style={{
            padding: 24,
            minHeight: 360,
          }}
        >
          <Divider orientation="center">Argos Hub</Divider>
          <Row
            gutter={{
              xs: 8,
              sm: 16,
              md: 24,
              lg: 32,
            }}
          >
        
            <Divider orientation="center">Admin Tools</Divider>
            <Col className="gutter-row" span={6}>
              <div style={style}>
                <a href="http://monitoring.pnta.de" target="_blank" rel="noreferrer">
                  Grafana Monitoring
                </a>
              </div>
            </Col>
            <Col className="gutter-row" span={6}>
              <div style={style}>
                <a href="https://monitoring.pnta.de/gridlocator/" target="_blank" rel="noreferrer">
                  Grid Locator
                </a>
              </div>
            </Col>
          </Row>
        </div>
    </Content>
      <Footer
        style={{
          textAlign: 'center',
        }}
      >
        OTTO Advertising
      </Footer>
    </Layout>
  </Layout>
)};
      

export default Hub;